import { Component } from '@angular/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { displayModalComponent, displayModalEditorComponent, ModalOptions } from '@myapp/features/widgets/models';
import { FormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-base-grid',
  standalone: true,
  templateUrl: './base-grid.component.html',
})
export abstract class BaseGridComponent extends BehaviorSubject<GridDataResult> {

  /*-------------------------- public properties --------------------*/

  public gridRequestObject: any = {};
  public loading: boolean = true;
  public take: number = 15;
  public skip: number = 0;
  public sort?: SortDescriptor[] = [{ field: "", dir: "desc" }];

  // For endless scrolling
  protected data: unknown[] = [];
  protected gridResponseData: GridDataResult = { data: this.data, total: 0 };
  protected completed = false;
  protected isTakeAndSkip = false;

  /*-------------------------- Constructor  --------------------------*/

  constructor(private modalService: NgbModal) {

    const emptyDataResult = {
      data: [],
      total: 0
    }

    super(emptyDataResult);
  }

  /*----------------------- abstract functions -----------------------*/

  abstract fetchGridData(): Observable<GridDataResult>;

  /*-------------------------- public methods ------------------------*/

  query(): void {
    if (!this.isTakeAndSkip) {
      this.gridRequestObject.page = (this.skip / this.take) + 1;
      this.gridRequestObject.pagesize = this.take;
    }
    else {
      this.gridRequestObject.skip = this.skip;
      this.gridRequestObject.take = this.take;
    }

    this.gridRequestObject.sort = this.sort![0].field + " " + this.sort![0].dir;

    this.fetchGridData()
      .subscribe((x: any) => super.next(x));
  }

  queryAll(): Observable<GridDataResult> {
    if (!this.isTakeAndSkip) {
      this.gridRequestObject.page = null;
      this.gridRequestObject.pagesize = null;
    }
    else {
      this.gridRequestObject.skip = this.skip;
      this.gridRequestObject.take = this.take;
    }

    this.gridRequestObject.sort = this.sort![0].field + " " + this.sort![0].dir;
    return this.fetchGridData();
  }

  refreshGrid(): void {
    this.skip = 0;
    this.data = [];
    this.query();
  }

  showEditorModal(size: string, options: ModalOptions, component: any, formGroup: FormGroup, isNew: boolean): NgbModalRef {
    return displayModalEditorComponent(component, size, options, this.modalService, formGroup);
  }

  showModal(size: string, options: ModalOptions, component: any, params: any[], isNew: boolean): NgbModalRef {
    return displayModalComponent(component, size, options, this.modalService, params);
  }

  /*----------------------------- events -----------------------------*/

  public pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.take = take;
    this.query();
  }

  public pageSizeChange(value: any): void {
    this.skip = 0;
    this.query();
  }

}
